import { render, staticRenderFns } from "./mobile_depot_info.vue?vue&type=template&id=01e18480&scoped=true&"
import script from "./mobile_depot_info.vue?vue&type=script&lang=js&"
export * from "./mobile_depot_info.vue?vue&type=script&lang=js&"
import style0 from "./mobile_depot_info.vue?vue&type=style&index=0&id=01e18480&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e18480",
  null
  
)

export default component.exports